import { useEffect } from "react";

export interface ArticleLike {
  category: string;
  title: string;
  meta?: string;
  image?: string;
  alt?: string;
  paragraphs: string[];
  deep?: boolean;
}

interface ArticleModalProps {
  article: ArticleLike | null;
  onClose: () => void;
}

export default function ArticleModal({ article, onClose }: ArticleModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    if (article) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [article, onClose]);

  if (!article) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-end justify-center sm:items-center">
      <button
        type="button"
        aria-label="关闭弹窗"
        onClick={onClose}
        className="absolute inset-0 bg-foreground-950/60 backdrop-blur-sm"
      ></button>
      <div
        role="dialog"
        aria-modal="true"
        className="relative z-10 flex max-h-[92vh] w-full flex-col overflow-hidden rounded-t-2xl bg-background-50 shadow-2xl sm:mx-6 sm:max-w-2xl sm:rounded-2xl"
      >
        <div className="flex items-center justify-between gap-4 border-b border-background-200 px-6 py-4">
          <div className="flex items-center gap-2">
            <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-semibold text-secondary-800">
              {article.category}
            </span>
            {article.deep && (
              <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-800">
                <i className="ri-scan-2-line" aria-hidden="true"></i>深度复盘
              </span>
            )}
          </div>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-100 text-foreground-600 transition-colors hover:bg-primary-100 hover:text-primary-700"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-6">
          <h3 className="font-fun text-2xl leading-snug text-foreground-950">{article.title}</h3>
          {article.meta && <p className="mt-3 text-sm text-foreground-500">{article.meta}</p>}
          {article.image && (
            <img src={article.image} alt={article.alt ?? article.title} className="mt-5 aspect-[16/9] w-full rounded-xl object-cover" />
          )}
          <div className="mt-5 space-y-4 text-[15px] leading-7 text-foreground-800">
            {article.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
          {article.deep && (
            <div className="mt-6 flex items-start gap-3 rounded-xl bg-primary-50 p-4 text-sm text-primary-800">
              <i className="ri-information-line mt-0.5 text-lg" aria-hidden="true"></i>
              <p>
                看吃瓜编辑部坚持"先求证、再发布"，上文仅为事件梳理，不代表对任何一方的倾向性结论。更多信息以官方权威渠道为准。
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}